module.exports = __webpack_public_path__ + "img/airdrop-icon.81856676.png";